import React from "react";
import { render } from 'react-dom'
import { createStore } from 'redux'
import { Provider } from 'react-redux'
import  mainReducer  from './reducers/index'
import ForgetUserNameAppComponent from './components/ForgetUserNameAppComponent';

// @deprecated

const store = createStore(mainReducer);
render(
    <div>
        <Provider store={store}>
            <ForgetUserNameAppComponent cmeUno={CmeUno} />
        </Provider>
    </div>
    , document.getElementById("forgetusername")
);


